import { IFormStatus } from 'components/organisms/forms/types';
import {
  FieldHelperProps,
  FieldInputProps,
  FieldMetaProps,
  FormikContextType,
  useField,
  useFormikContext,
} from 'formik';

export interface IFormikContextType<T> extends FormikContextType<T> {
  status?: IFormStatus<T>;
}

export interface ICustomFieldMetaProps<FieldType, FormType = {}>
  extends FieldMetaProps<FieldType> {
  status?: IFormStatus<FormType>;
}

export const useFormikField = <FieldType, FormType = {}>(
  name: string
): [
  FieldInputProps<FieldType>,
  ICustomFieldMetaProps<FieldType, FormType>,
  FieldHelperProps<FieldType>
] => {
  const { submitCount, status }: IFormikContextType<FormType> =
    useFormikContext<FormType>();
  const [field, meta, helper] = useField<FieldType>(name);

  const customMeta: ICustomFieldMetaProps<FieldType, FormType> = {
    ...meta,
    status: status,
    error: submitCount >= 1 ? meta.error : undefined,
  };

  return [field, customMeta, helper];
};
